import axios from "axios";
import { toast } from "react-toastify";
import { GET_LEAD_FORM_REQUEST, GET_SURVEY_FORM_SUCCESS, GET_SURVEY_FORM_FAIL, GET_SURVEY_SECTIONS_REQUEST, GET_SURVEY_SECTIONS_SUCCESS, GET_SURVEY_SECTIONS_FAIL, SUBMIT_SURVEY_FORM_SUCCESS, SUBMIT_SURVEY_FORM_FAIL, SUBMIT_SURVEY_FORM_REQUEST, GET_SURVEY_RESULT_REQUEST, GET_SURVEY_RESULT_SUCCESS, GET_SURVEY_RESULT_FAIL, GET_SURVEY_REPORT_REQUEST, GET_SURVEY_REPORT_SUCCESS, GET_SURVEY_REPORT_FAIL, GET_DEFAULT_REPORT_REQUEST, GET_DEFAULT_REPORT_SUCCESS, GET_DEFAULT_REPORT_FAIL, GET_SURVEY_DETAIL_REQUEST,GET_SURVEY_DETAIL_SUCCESS, GET_SURVEY_DETAIL_FAIL,  GET_STAGE_FAIL, GET_STAGE_REQUEST, GET_STAGE_SUCCESS, GET_COUNTRY_CODES_REQUEST,
    GET_COUNTRY_CODES_SUCCESS,
    GET_COUNTRY_CODES_FAIL, GET_ACTIVE_WEBHOOKS_REQUEST,
  GET_ACTIVE_WEBHOOKS_SUCCESS,
  GET_ACTIVE_WEBHOOKS_FAIL,TRIGGER_WEBHOOK_SUCCESS, TRIGGER_WEBHOOK_FAIL } from "../constant";

export const getSurveyFormData = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_LEAD_FORM_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getQues`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: GET_SURVEY_FORM_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET SURVEY FORM DATA FAIL", err)
                dispatch({ type: GET_SURVEY_FORM_FAIL });
            })
    }
}

export const getSurveySectionData = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_SECTIONS_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getSections`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: GET_SURVEY_SECTIONS_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET SURVEY SECTION FAIL", err)
                dispatch({ type: GET_SURVEY_SECTIONS_FAIL });
            })
    }
}

export const submitResponseData = (data) => {
    return async (dispatch) => {
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/submitRes`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
            })
            .catch(err => {
                console.error("SUBMIT RESPONSE ERROR", err)
            })
    }
}

export const submitSurveyData = (data, navigate) => {
    return async (dispatch) => {
        let token = localStorage.getItem("customer_token")
        dispatch({ type: SUBMIT_SURVEY_FORM_REQUEST })
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/submitSurvey`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: SUBMIT_SURVEY_FORM_SUCCESS });
                const emailOn = res?.data?.email_enabled !== false;
                toast.success(
                    emailOn
                        ? "Thanks! Your survey was submitted. We'll email your report shortly."
                        : "Thanks! Your survey was submitted successfully.",
                    { position: "top-right", autoClose: 5000 }
                );
                navigate(`/thank-you/${data.survey_id}/${data.ss_id}`)
            })
            .catch(err => {
                console.error("SUBMIT RESPONSE ERROR", err)
                dispatch({ type: SUBMIT_SURVEY_FORM_FAIL });
            })
    }
}

export const getSurveyResult = (data) => {
    return async (dispatch) => {
        let token = localStorage.getItem("customer_token")
        dispatch({ type: GET_SURVEY_RESULT_REQUEST })
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getResult`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: GET_SURVEY_RESULT_SUCCESS, payload: res.data?.data })
            })
            .catch(err => {
                console.error("SUBMIT RESPONSE ERROR", err)
                dispatch({ type: GET_SURVEY_RESULT_FAIL })
            })
    }
}

export const getSurveyReport = (data) => {
    return async (dispatch) => {
        let token = localStorage.getItem("customer_token")
        dispatch({ type: GET_SURVEY_REPORT_REQUEST })
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/showReport`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: GET_SURVEY_REPORT_SUCCESS, payload: res.data?.data })
            })
            .catch(err => {
                dispatch({ type: GET_SURVEY_REPORT_FAIL })
            })
    }
}

export const getDefaultReport = (data) => {
    return async (dispatch) => {
        let token = localStorage.getItem("customer_token")
        dispatch({ type: GET_DEFAULT_REPORT_REQUEST });
        let options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/survey/getDefaultReport?survey_id=${data}`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        };
        await axios(options)
            .then(response => {
                dispatch({ type: GET_DEFAULT_REPORT_SUCCESS, payload: response.data?.data })
            })
            .catch(err => {
                dispatch({ type: GET_DEFAULT_REPORT_FAIL })
            })
    }
}

export const getSurveyDetail = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_DETAIL_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getSurveyDetail`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                console.log(res);
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: GET_SURVEY_DETAIL_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET SURVEY DETAIL FAIL", err)
                dispatch({ type: GET_SURVEY_DETAIL_FAIL });
            })
    }
}

//Stages
export const getStages = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_STAGE_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getStageList`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                console.log(res);
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token)
                dispatch({ type: GET_STAGE_SUCCESS, payload: res?.data?.data });
            })
            .catch(err => {
                console.error("GET SURVEY DETAIL FAIL", err)
                dispatch({ type: GET_STAGE_FAIL });
            })
    }
}

export const getCountryCodes = () => {
    return async (dispatch) => {
        dispatch({ type: GET_COUNTRY_CODES_REQUEST });
        let token = localStorage.getItem("customer_token");

        let options = {
            method: "GET",
            url: `${process.env.REACT_APP_API_URL}/frnt/getCountryCodes`,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        };

        await axios(options)
            .then((res) => {
                console.log(res);
                if (res?.data?.token) localStorage.setItem("customer_token", res.data.token);
                dispatch({
                    type: GET_COUNTRY_CODES_SUCCESS,
                    payload: res?.data?.data?.countryCodes,
                });
            })
            .catch((err) => {
                console.error("GET COUNTRY CODES FAIL", err);
                dispatch({ type: GET_COUNTRY_CODES_FAIL });
            });
    };
};

export const getActiveWebhooks = (survey_id) => {
  return async (dispatch) => {
    dispatch({ type: GET_ACTIVE_WEBHOOKS_REQUEST });

    const token = localStorage.getItem("customer_token");

    const options = {
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/frnt/getActiveWebhooks/${survey_id}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios(options)
      .then((res) => {
        if (res?.data?.token) localStorage.setItem("customer_token", res.data.token);
        dispatch({
          type: GET_ACTIVE_WEBHOOKS_SUCCESS,
          payload: res?.data?.data || [],
        });
      })
      .catch((err) => {
        console.error("GET ACTIVE WEBHOOKS FAIL", err);
        dispatch({ type: GET_ACTIVE_WEBHOOKS_FAIL });
      });
  };
};



export const triggerWebhookBackend = (survey_id, event_name, ss_id) => {
  return async (dispatch) => {
    const token = localStorage.getItem("customer_token");

    try {
      const res = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}/frnt/triggerWebhook`,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          survey_id,
          event_name,
          ss_id,
        },
      });

      if (res?.data?.token) localStorage.setItem("customer_token", res.data.token);

      dispatch({
        type: TRIGGER_WEBHOOK_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      console.error("TRIGGER WEBHOOK FAIL", err);
      dispatch({
        type: TRIGGER_WEBHOOK_FAIL,
        payload: err?.response?.data || { msg: "Webhook trigger failed" },
      });
    }
  };
};
